var _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPlaidinline = function SvgPlaidinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 106,
    height: 40,
    fill: "none",
    viewBox: "0 0 106 40"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#plaid_inline_svg__a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#111",
    fillRule: "evenodd",
    d: "M55.732 13.708c-.89-.75-2.407-1.123-4.554-1.123h-4.842v14.988h3.62v-4.698h1.623c1.968 0 3.412-.434 4.33-1.302 1.035-.974 1.556-2.27 1.556-3.887 0-1.678-.578-3.004-1.733-3.978m-4.243 5.776h-1.532v-3.508h1.376c1.674 0 2.511.588 2.511 1.765 0 1.16-.785 1.742-2.355 1.742m12.172-6.9h-3.776v14.988h8.152V24.18h-4.376zm11.774 0-5.931 14.988h4.065l.777-2.179H79.5l.71 2.179h4.111l-5.889-14.988h-2.997m-.045 9.775 1.555-5.123 1.532 5.123h-3.088.001",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "plaid_inline_svg__b",
    width: 106,
    height: 41,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 40.001h106v-40H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#plaid_inline_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#111",
    fillRule: "evenodd",
    d: "M86.207 27.572h3.777V12.584h-3.777v14.988m18.439-12.179a6.21 6.21 0 0 0-1.801-1.73c-1.14-.72-2.695-1.078-4.665-1.078h-4.975v14.987h5.82c2.103 0 3.791-.688 5.064-2.067 1.274-1.377 1.91-3.206 1.91-5.483 0-1.812-.452-3.355-1.354-4.629h.001m-6.043 8.786h-1.621v-8.202h1.643c1.156 0 2.043.363 2.666 1.085.622.722.933 1.746.933 3.072 0 2.697-1.207 4.045-3.621 4.045M15.679 0 3.44 3.211.068 15.537l4.218 4.338L0 24.141l3.174 12.38 12.185 3.41 4.287-4.267 4.218 4.337 12.238-3.21 3.372-12.327-4.217-4.336 4.286-4.266L36.369 3.48 24.182.07l-4.285 4.266L15.679 0Zm-7.51 5.581 6.446-1.692 2.82 2.899-4.112 4.091L8.17 5.582M22.32 6.828l2.864-2.85 6.419 1.796-5.239 5.213-4.044-4.16M3.93 14.525l1.775-6.492 5.153 5.299-4.11 4.091-2.819-2.898Zm24.856-1.047 5.239-5.215 1.67 6.522-2.863 2.851-4.046-4.158m-13.041-.107 4.111-4.091 4.044 4.159-4.11 4.091-4.045-4.159m-6.574 6.543 4.11-4.092 4.047 4.16-4.112 4.09-4.045-4.158m13.043.107 4.11-4.092 4.045 4.16-4.111 4.09-4.044-4.158m-18.37 5.196 2.865-2.852 4.044 4.16-5.237 5.212-1.672-6.52m11.795 1.346 4.111-4.091 4.045 4.159-4.11 4.091-4.046-4.159m13.041.108 4.112-4.091 2.819 2.897-1.775 6.493-5.156-5.299M7.94 34.23l5.238-5.214 4.046 4.158-2.865 2.853-6.419-1.798v.001Zm14.17-1.016 4.11-4.091 5.154 5.298-6.446 1.692-2.818-2.899",
    clipRule: "evenodd"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "plaid_inline_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .001h106v40H0z"
  })))));
};
export default SvgPlaidinline;